import * as React from "react";
import { SVGProps } from "react";
const SvgComponent = ({
  width = 64,
  height = 64,
  ...props
}: SVGProps<SVGSVGElement> & {
  width?: number;
  height?: number;
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 64 64"
    fill="none"
    {...props}
  >
    <path
      fill="#30BBA9"
      d="M63.69 2.061c-.03.153-.122.26-.198.398-3.455 5.702-6.91 11.403-10.38 17.105-3.638 6.008-7.292 12.016-10.93 18.023-.183.306-.397.535-.718.703l-9.63 5.366c-4.816 2.69-9.616 5.366-14.431 8.056-3.776 2.11-7.567 4.22-11.358 6.329-1.101.611-2.217 1.238-3.318 1.85-.091.045-.168.122-.305.122-.016-.107.06-.184.107-.275 1.421-2.34 2.858-4.678 4.28-7.017 1.957-3.21 3.929-6.42 5.885-9.646 3.165-5.167 6.314-10.334 9.478-15.516.275-.458.566-.917.84-1.376.123-.214.291-.366.49-.489 1.452-.856 2.89-1.712 4.341-2.568l8.53-5.045c5.121-3.026 10.242-6.068 15.363-9.095 3.822-2.262 7.628-4.525 11.45-6.787.122-.077.26-.138.397-.199a.18.18 0 0 1 .107.061Z"
    />
    <path
      fill="#F4793F"
      d="M62.605 62c-.137-.046-.199-.168-.29-.275l-6.283-7.43c-2.492-2.95-4.968-5.9-7.46-8.835-1.712-2.018-3.424-4.051-5.136-6.069l-.2-.244c-.274-.322-.305-.291-.06-.688a50.83 50.83 0 0 0 .932-1.53c2.14-3.47 4.265-6.955 6.405-10.425a815.067 815.067 0 0 1 2.95-4.8c.077-.107.138-.229.23-.336.03-.046.092-.03.107.015.03.031.03.077.046.123.489 2.216.963 4.448 1.452 6.665.398 1.819.795 3.638 1.192 5.442.55 2.553 1.116 5.12 1.667 7.674.382 1.788.78 3.577 1.177 5.365.535 2.446 1.07 4.877 1.59 7.322.489 2.217.978 4.449 1.452 6.666.06.305.137.61.199.917.03.152.076.305.03.443ZM1 4.721c.138 0 .183-.015.23 0 12.916 3.164 25.818 6.313 38.736 9.478-.016.168-.153.199-.245.26-1.04.626-2.094 1.253-3.134 1.88-4.265 2.553-8.53 5.12-12.795 7.674-.535.32-.412.32-.856-.077-1.528-1.33-3.042-2.66-4.57-4.005-1.804-1.574-3.608-3.149-5.412-4.739a396.383 396.383 0 0 1-3.79-3.332c-1.866-1.636-3.746-3.271-5.611-4.907L1.306 4.98c-.107-.046-.184-.122-.306-.26Z"
    />
  </svg>
);
export default SvgComponent;
